import { useCallback } from 'react';
import { create } from 'zustand';
export const useConfirmDialogState = create((set) => ({
    confirmOptions: undefined,
    setConfirmOptions: (options) => set({ confirmOptions: options }),
}));
export function useConfirmDialog() {
    const setConfirmOptions = useConfirmDialogState((state) => state.setConfirmOptions);
    return {
        requestConfirm: useCallback((request) => {
            setConfirmOptions(request);
        }, [setConfirmOptions]),
        clearConfirm: useCallback(() => {
            setConfirmOptions(undefined);
        }, [setConfirmOptions]),
    };
}
//# sourceMappingURL=useConfirmDialog.js.map